import gql from "graphql-tag";
const PUBLIC_ARTICLES = gql`
	query (
		$where: PublicArticleFilterInput
		$order: [PublicArticleSortInput!]
		$take: Int
		$skip: Int
	) {
		publicArticles(where: $where, order: $order, take: $take, skip: $skip) {
			items {
				id
				createdOn
				createdBy {
					id
					name
				}
				modifiedOn
				modifiedBy {
					id
					name
				}
				title
				code
			}
		}
	}
`;
gql`
	query (
		$where: PublicArticleFilterInput
		$order: [PublicArticleSortInput!]
		$take: Int
		$skip: Int
	) {
		publicArticles(where: $where, order: $order, take: $take, skip: $skip) {
			items {
				title
				code
			}
		}
	}
`;
const PUBLIC_ARTICLE_FOR_VIEW = gql`
	query ($code: String!) {
		publicArticleByCode(code: $code) {
			id
			createdOn
			title
			code
			content
			metaTitle
			metaDescription
		}
	}
`;
const PUBLIC_ARTICLES_FOR_EDIT = gql`
	query ($where: PublicArticleFilterInput) {
		publicArticlesForEdit(where: $where) {
			items {
				id
				createdOn
				createdBy {
					name
				}
				modifiedOn
				modifiedBy {
					name
				}
				title
				metaTitle
				metaDescription
				content
				code
				culture {
					id
				}
			}
		}
	}
`;
const ADD_OR_EDIT_PUBLIC_ARTICLE = gql`
	mutation ($inputs: [BaseContentInput!]!) {
		result: addOrEditPublicArticle(inputs: $inputs)
	}
`;
const DELETE_PUBLIC_ARTICLE = gql`
	mutation ($code: String!) {
		deletePublicArticle(code: $code)
	}
`;
export {
  ADD_OR_EDIT_PUBLIC_ARTICLE,
  DELETE_PUBLIC_ARTICLE,
  PUBLIC_ARTICLES,
  PUBLIC_ARTICLES_FOR_EDIT,
  PUBLIC_ARTICLE_FOR_VIEW
};
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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
